import { render, staticRenderFns } from "./KnowledgeHub.vue?vue&type=template&id=9baadfb4&scoped=true&"
import script from "./KnowledgeHub.vue?vue&type=script&lang=js&"
export * from "./KnowledgeHub.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeHub.vue?vue&type=style&index=0&id=9baadfb4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baadfb4",
  null
  
)

export default component.exports